<template>
  <div>
    <b-modal ref="modalRotograma" size="lg" @hide="hideModal">
      <template #modal-footer="{ close }">
        <div class="right">
          <b-button @click="close">
            {{ $t(`geral.close`) }}
          </b-button>
        </div>
      </template>

      <!-- title cargo -->
      <h3 style="margin-top: 10px">
        {{ $t("tracking.cargo.data") }}
      </h3>

      <b-row>
        <b-col>
          <!-- cargoId -->
          <base-row-detail
            :label="`${$t('tracking.cargoExpense.model.cargo')} :`"
            :value="`${rotogram.cargo}`"
          />

          <!-- nameClient -->
          <base-row-detail
            :label="`${$t('tracking.cargo.clientName')} :`"
            :value="`${rotogram.nameClient}`"
          />

          <!-- branch -->
          <base-row-detail
            :label="`${$t('tracking.cargo.companyBranchName')} :`"
            :value="`${rotogram.branch}`"
          />

          <!-- driverName -->
          <base-row-detail
            :label="`${$t('tracking.cargo.driverName')} :`"
            :value="`${rotogram.driverName}`"
          />

          <!-- carrierName -->
          <base-row-detail
            :label="`${$t('tracking.cargo.transportNumber')} :`"
            :value="`${rotogram.carrierName}`"
          />
        </b-col>
      </b-row>

      <!-- title Rotogram -->
      <h3 style="margin-top: 10px">
        {{ `${$t("tracking.cargo.rotogramCargo")}` }}
      </h3>

      <b-row v-if="rotogram.rotogramaId != 0">
        <b-col style="border-top: 50px">
          <!-- rotogramaId -->
          <base-row-detail
            :label="`Rotograma ID:`"
            :value="`${rotogram.rotogramaId}`"
          />

          <!-- nomeOrigemCity -->
          <base-row-detail
            :label="`Cidade de origem:`"
            :value="
              `${rotogram.nomeOrigemCity}` +
              ' - ' +
              `${rotogram.acronymStateOrigin}`
            "
          />

          <!-- nomeDestinyCity -->
          <base-row-detail
            :label="`Cidade de destino:`"
            :value="
              `${rotogram.nomeDestinyCity}` +
              ' - ' +
              `${rotogram.acronymStateDestiny}`
            "
          />

          <!-- complement -->
          <b-form-group>
            <base-row-detail
              v-if="
                this.rotogram.complement != '' &&
                this.rotogram.complement != null
              "
              :label="`Complemento:`"
              :value="`${rotogram.complement}`"
            />
            <base-row-detail
              v-else
              :label="`Complemento:`"
              :value="`Não Informado`"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <span v-if="rotogram.rotogramaId == 0">
        {{ $t(`tracking.cargo.noneRotogram`) }}
      </span>
    </b-modal>
  </div>
</template>

<script>
export default {
  components: {
    BaseRowDetail: () => import("@/components_rms/base/BaseRowDetail.vue"),
  },
  data() {
    return {
      rotogram: {
        rotogramaId: 0,
        acronymStateOrigin: "",
        acronymStateDestiny: "",
        cargo: "",
        nameClient: "",
        branch: "",
        driverName: "",
        carrierName: "",
        originStateId: "",
        originCityId: "",
        nomeOrigemCity: "",
        destinyStateId: "",
        destinyCityId: "",
        nomeDestinyCity: "",
        complement: "",
      },
    };
  },
  methods: {
    GetRotograma(cargoId) {
      this.$api
        .get(`/carga/rotograma/${cargoId}`)
        .then((response) => {
          this.rotogram = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    show(cargoId) {
      this.$refs.modalRotograma.show();
      this.GetRotograma(cargoId);
    },
    hideModal() {
      this.rotogram = {
        rotogramaId: "",
        acronymStateOrigin: "",
        acronymStateDestiny: "",
        cargo: "",
        nameClient: "",
        branch: "",
        driverName: "",
        carrierName: "",
        originStateId: "",
        originCityId: "",
        nomeOrigemCity: "",
        destinyStateId: "",
        destinyCityId: "",
        nomeDestinyCity: "",
        complement: "",
      };
    },
  },
};
</script>
<style>
.right {
  text-align: right;
  width: 100%;
}
</style>